// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Fix: wick-ui-lib Tailwind preflight sets * { font-family: Fira Sans }
 * which overrides the wu-icon font-family on icon elements.
 * This file must be imported AFTER both wick-ui-lib and wick-ui-icon CSS.
 */
[class^="wc-"],
[class^="wm-"],
[class^="wp-"],
[class*=" wc-"],
[class*=" wm-"],
[class*=" wp-"] {
  font-family: 'wu-icon' !important;
  font-style: normal !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*
 * Fix: wick-ui-lib icon code mapping uses short names (wp-bi, wp-cx)
 * but the icon font uses full names (wp-business-intelligence, wp-customer-experience).
 * Add aliases so both resolve to the correct glyph.
 */
.wp-bi::before { content: "\\f901"; }
.wp-cx::before { content: "\\f904"; }
`, "",{"version":3,"sources":["webpack://./src/styles/icon-fix.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;;;;;;EAME,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;EAIE;AACF,iBAAiB,gBAAgB,EAAE;AACnC,iBAAiB,gBAAgB,EAAE","sourcesContent":["/*\n * Fix: wick-ui-lib Tailwind preflight sets * { font-family: Fira Sans }\n * which overrides the wu-icon font-family on icon elements.\n * This file must be imported AFTER both wick-ui-lib and wick-ui-icon CSS.\n */\n[class^=\"wc-\"],\n[class^=\"wm-\"],\n[class^=\"wp-\"],\n[class*=\" wc-\"],\n[class*=\" wm-\"],\n[class*=\" wp-\"] {\n  font-family: 'wu-icon' !important;\n  font-style: normal !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/*\n * Fix: wick-ui-lib icon code mapping uses short names (wp-bi, wp-cx)\n * but the icon font uses full names (wp-business-intelligence, wp-customer-experience).\n * Add aliases so both resolve to the correct glyph.\n */\n.wp-bi::before { content: \"\\f901\"; }\n.wp-cx::before { content: \"\\f904\"; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
